module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAOVBMVEUAAAAW2LkW17gW1rgn6cEW17gX1rgX17gX17cX17gW17cZ17cd270X3LkW17cW1rf////6/v0Y1rfReIHkAAAAD3RSTlMAgNbzC/7ov6qlclIjFvIAYqc6AAAA2UlEQVQ4y52VUQ6EIAxE24KwIFrw/ofdZLMxaotF58uPF8YBOsBZJadIzlFMuUBXCxIfRLiomEfHFzn0kpsDKwrzlcOJVU14tv1wV5+j/c6p5MGXb4V7jukenP6JfGBDwUvjWmvPfHE26BaRpNbWy0N8UVMWJYDy+zDdC+QxMENiIe1PE0RBqYtGoDGQwAlKdXewjoEr0BhIaphNpo6QxsAEeWwfMxSdkkcINAKSHJhta02CKC5u619cQBtEOVyaLwf/bFztAnhYKXZJvag9u0jtan5d9vbz8QWjKUgFV4zygwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sign/icon_arrow.png
// module id = OpE0
// module chunks = 1